module.exports = __webpack_public_path__ + "img/ircat-pic.744d3544.png";